export default __webpack_public_path__ + "static/media/noData.970b8ced.png";